export default __webpack_public_path__ + "static/favicon-d9a55450ea601b741536a560226e31e3.ico";